export function get_api_path() {
//    return("http://192.168.2.29:3300/");
//    return("https://erp.dgaspctl.ro:2053/api3/");
    return(window.location.origin + "/api3/");
}
